/**
 * Registro de e-mail (PLAN §9, fatia k).
 *
 * Existe pela mesma razão de `file_accesses`: numa auditoria a pergunta é **"o
 * fornecedor foi avisado?"**, e a resposta não pode depender de alguém lembrar.
 *
 * O corpo da mensagem **não** é guardado. O texto é gerado do mesmo dado que
 * continua no banco, e uma cópia congelada dele viraria uma segunda fonte da
 * verdade — o erro que a nota percentual da planilha cometeu.
 */
export const EmailKind = {
    RNC_ISSUED: 'RNC_ISSUED',
    PERIOD_PUBLISHED: 'PERIOD_PUBLISHED',
    SUPPLIER_ALERT: 'SUPPLIER_ALERT',
    QUALITY_DIGEST: 'QUALITY_DIGEST',
    ACCOUNT_INVITE: 'ACCOUNT_INVITE',
    PASSWORD_RESET: 'PASSWORD_RESET',
    TEST: 'TEST',
};
export const EMAIL_KIND_LABEL = {
    RNC_ISSUED: 'RNC emitida',
    PERIOD_PUBLISHED: 'Competência publicada',
    SUPPLIER_ALERT: 'Alerta de documento',
    QUALITY_DIGEST: 'Resumo da Qualidade',
    ACCOUNT_INVITE: 'Convite de acesso',
    PASSWORD_RESET: 'Redefinição de senha',
    TEST: 'Teste de configuração',
};
export const EmailStatus = {
    /** Saiu pelo Microsoft Graph. */
    SENT: 'SENT',
    /** Gravado em disco: `MAIL_DRY_RUN`, ou Graph sem configuração. */
    DRY_RUN: 'DRY_RUN',
    FAILED: 'FAILED',
};
export const EMAIL_STATUS_LABEL = {
    SENT: 'Enviado',
    DRY_RUN: 'Ensaio',
    FAILED: 'Falhou',
};
//# sourceMappingURL=mail.js.map